var $727da781aca847f9$exports = {};
$727da781aca847f9$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};


export {$727da781aca847f9$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
